module.exports = __webpack_public_path__ + "static/media/logo-with-icons-white.3aea7cbc.svg";